import { MemberType } from "src/types/organization/OrganizationMember"

export const MemberTypeLabel: { [key in MemberType]: string } = {
  [MemberType.Representative]: "代表者",
  [MemberType.General]: "一般メンバー",
  [MemberType.GeneralWithContactAuthorization]: "連絡メンバー",
}
